import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';
import './toggle.css';

interface ToggleProps {
    checked: boolean;
    onToggle: () => void;
    disabled: boolean;
}

const Toggle = ({ checked, onToggle, disabled }: ToggleProps) => {
    const { language } = useApp();

    const labelClasses = disabled ? 'toggle toggle-disabled' : 'toggle';

    return (
        <label className={labelClasses} role="switch" aria-disabled={disabled}>
            <input
                className="toggle-checkbox"
                type="checkbox"
                checked={checked}
                onChange={onToggle}
                disabled={disabled}
            />
            <div className="toggle-indicator-slider" />
            <div className="toggle-indicator-on">{translations[language].COMMON_on}</div>
            <div className="toggle-indicator-off">{translations[language].COMMON_off}</div>
        </label>
    );
};

export default Toggle;
